export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/sparkles-icon.png?49cadd4e938a9087967339b7ca97d9d5";